<template>
  <payment-flow-animation
    :result="result"
    flow="payment"
    :overlay="false"
    :success-action-label="actionLabel"
    :error-action-label="actionLabel"
    @action="goHome"
  />
</template>

<script>
import PaymentFlowAnimation from "@/components/payment/PaymentFlowAnimation";

export default {
  name: "PaymentCancel",
  components: {
    PaymentFlowAnimation,
  },
  computed: {
    result() {
      return {
        success: false,
        message: this.$t("pay.paymentCanceled"),
      };
    },
    actionLabel() {
      if (this.$i18n && this.$i18n.locale === "en") return "Home";
      if (this.$i18n && this.$i18n.locale === "ru") return "На главную";
      return "На головну";
    },
  },
  methods: {
    async goHome() {
      await this.$router.push({ name: "Home" });
    },
  },
};
</script>
